import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { downloadDisciplinePack, listDiscipline, listRounds } from '../api/portal';
import { ApiError } from '../api/client';

export function DisciplinePage() {
  const rounds = useQuery({ queryKey: ['portal-rounds'], queryFn: listRounds });
  const [round, setRound] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const data = useQuery({
    queryKey: ['portal-discipline', round],
    queryFn: () => listDiscipline(round || undefined),
  });
  const rows = data.data?.incidents ?? [];

  return (
    <div>
      <div className="page-head">
        <div className="page-kicker">Liga</div>
        <h1 className="page-title">Disciplinska komisija</h1>
        <p className="page-sub">
          Crveni, drugi žuti, 2 min, 7m — po igraču i kolu, plus zapisnik i klip incidenta.
        </p>
      </div>
      <div className="mb-4 flex flex-wrap items-end gap-2">
        <label>
          <span className="label">Kolo</span>
          <select className="input" value={round} onChange={(e) => setRound(e.target.value)}>
            <option value="">Sva kola</option>
            {(rounds.data ?? []).map((r) => (
              <option key={r.key} value={r.key}>{r.label}</option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className="btn-primary"
          onClick={() => downloadDisciplinePack(round || undefined)
            .then(() => setMsg('ZIP preuzet.'))
            .catch((e) => setMsg(e instanceof ApiError ? e.message : String(e)))}
        >
          Preuzmi pack
        </button>
      </div>
      {msg && <div className="card mb-3 p-3 text-sm text-slate-200">{msg}</div>}
      <div className="card p-4">
        <table className="table">
          <thead>
            <tr>
              <th>Meč</th><th>Min</th><th>Igrač</th><th>Tip</th><th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((e) => (
              <tr key={e.id}>
                <td className="text-white">{e.home} vs {e.away}</td>
                <td className="tabular-nums text-slate-400">{e.minute ?? '—'}</td>
                <td>{e.player || '—'} <span className="text-slate-500">{e.team}</span></td>
                <td className="text-xs text-slate-300">{e.event_type}</td>
                <td className="flex flex-wrap gap-1">
                  <Link to={`/matches/${e.match_id}/report`} className="btn-ghost text-xs">Zapisnik</Link>
                  {e.clip_url && (
                    <a href={String(e.clip_url)} className="btn-ghost text-xs" target="_blank" rel="noreferrer">Klip</a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <div className="py-6 text-center text-sm text-slate-500">Nema incidentata u ovom filteru.</div>}
      </div>
    </div>
  );
}
